import styled from 'styled-components';

export const ContainerDiv = styled.div`
    margin: 20px;
    width:'auto'
`;

export const AnchorSpan = styled.span`
    cursor: pointer;
    color: #336094;
    &:hover {
        text-decoration: underline;
    }
`;

export const RedSpan = styled.span`
    background-color: red;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    margin-bottom: 10px;
    position: absolute;
    margin-left: 15px;
`;

export const ErrorCount = styled.span`
    display: inline-block;
    width: 20px;
    height: 23px; 
    border-radius: 10px;
    background-color: #DD1D21;
    color: #FFFFFF;
    margin-left: 6px;
    padding-left: 6px; 
`;

export const ErrorCell = styled.span`
    color: #DD1D21;
`;

export const NewCell = styled.span`
    color: #343434;
`;
export const ProcessingCell = styled.span`
    color: #FFC600;
`;
export const SuccessCell = styled.span`
    color: #6FB993;
`;
